import * as R from './route-classes'
import Router from './router'
const Routes = new Router()
Routes.New = {
    'rounds': new R.Rounds,
    'matches': new R.Matches,
    'insert-bet': new R.InsertBet,
    'update-bet': new R.UpdateBet,
    'results': new R.Results,
    'login': new R.Login,
    'forgot-password': new R.ForgotPassword,
    'change-password': new R.ChangePassword,
    'unsubscribe': new R.Unsubscribe,
    'my-profile-select':new R.MyProfileSelect,
    'my-profile-update':new R.MyProfileUpdate,
    'registration': new R.Registration,
    'user-confirmation':new R.UserConfirmation,
    'flags': new R.Flags,
    'leaderboards': new R.Leaderboards,
    'create-league': new R.CreateLeague,
    'join-league': new R.JoinLeague,
    'send-league-code': new R.SendLeagueCode,
    'user-leagues': new R.UserLeagues,
    'upcoming-fixtures': new R.UpcomingFixtures,
    'usr': new R.Usr,
    'get-leaderboard': new R.LeaderboardFeed,
    'get-team-info': new R.TeamFeed,
    'get-player-info': new R.PlayerFeed,
    'get-last-matches-info':new R.LastMatchesFeed
}
export default Routes


// WEBPACK FOOTER //
// ./src/Socket/routes.ts